import { render, staticRenderFns } from "./BlockMenu.vue?vue&type=template&id=190fe000&scoped=true&"
import script from "./BlockMenu.vue?vue&type=script&lang=js&"
export * from "./BlockMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190fe000",
  null
  
)

export default component.exports